<header class="dashboard-header d-flex justify-content-between align-items-center bg-white border-bottom px-4">
  <!-- Left: logo -->
  <div class="d-flex align-items-center gap-3">
    <img src="assets/DATAstream-Logo-updated.png" alt="DATAstream Logo" class="logo-img" />
    <div class="logo-divider"></div>
    <span class="tenant-text">SUPERADMIN</span>
  </div>

  <!-- Right: all services + user menu -->
  <div class="d-flex align-items-center gap-3">
    <div class="dropdown">
      <button
        type="button"
        class="btn all-services-btn"
        data-bs-toggle="dropdown"
        title="All Services"
      >
        <i class="bi bi-grid"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end p-3 all-services-dropdown">
        <h6 class="text-muted small fw-bold mb-3">ALL SERVICES</h6>
        <p class="text-muted small mb-0">No services available.</p>
      </div>
    </div>

    <div class="dropdown">
      <div class="d-flex align-items-center gap-2 user-info" data-bs-toggle="dropdown">
        <div class="d-flex flex-column lh-sm">
          <span class="user-name">Suraj Kumar</span>
          <span class="user-email">suraj.kumar&#64;slipstream-it.com</span>
        </div>
      </div>
      <div class="dropdown-menu dropdown-menu-end">
        <button type="button" class="dropdown-item d-flex align-items-center gap-2">
          <i class="bi bi-person"></i>
          <span>Profile</span>
        </button>
        <button type="button" class="dropdown-item d-flex align-items-center gap-2 text-danger">
          <i class="bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </div>
</header>
